import { render, staticRenderFns } from "./zhongxin_policy.vue?vue&type=template&id=4581efcf&scoped=true"
import script from "./zhongxin_policy.vue?vue&type=script&lang=js"
export * from "./zhongxin_policy.vue?vue&type=script&lang=js"
import style0 from "./zhongxin_policy.vue?vue&type=style&index=0&id=4581efcf&prod&scoped=true&lang=less"
import style1 from "./zhongxin_policy.vue?vue&type=style&index=1&id=4581efcf&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4581efcf",
  null
  
)

export default component.exports